import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs'
const headers = new Headers()
headers.append('Accept', 'application/json')
const options = { responseType: 'text' }
const httpOptions = {
  responseType: 'arraybuffer' as 'json',
}
@Injectable({
  providedIn: 'root',
})
export class PDFSERVICE extends BehaviorSubject<any[]> {
  private data: any[] = []

  constructor(private _http: HttpClient) {
    super([])
  }
  /*  Getpdfservice(): Observable<any> {
    return this._http.get<any[]>(`/GetDisclosure/GetFieldNames`).pipe(catchError(this.handleError));
  } */
  /*   Getpdfservice(): Observable<HttpResponse<ArrayBuffer>> {
    return this._http.get<any[]>(`/GetDisclosure/CreatePDFss`, { responseType: 'arraybuffer', observe: 'response'}).pipe(catchError(this.handleError));
  } */
  /*   Getpdfservice(): Observable<HttpResponse<ArrayBuffer>> {
    return this._http.get(`/GetDisclosure/CreatePDFss`, { responseType: 'arraybuffer', observe: 'response' }).pipe(catchError(this.handleError));
  } */
  GetPdfService(path: string, clientId: number) {
    const body = { 
      name: path, 
      clientId: clientId 
    };
    this.checkPopupBlocker();
    return this._http.post(
      '/api/GetDisclosure/CreatePDFss?clientId=' + clientId + '&name=' + path,  body,
      { responseType: 'blob' },
    )
  }
  checkPopupBlocker(): void {
    const popup = window.open('', '_blank');

    if (popup === null || typeof(popup) === 'undefined') {
      // Popup is blocked
      alert('Popup is blocked. Please disable your popup blocker.');
    } else {
      // Popup is not blocked
      popup.close();
    }
  }
  getformlist(forms: string) {
    return this._http.post('/api/GetDisclosure/GetDisclosureForms', forms, {
      responseType: 'blob',
    })
  }
  getPdfDisclosureForms(forms: string[]) {
    return this._http.post('/api/GetDisclosure/GetDisclosureFormsmerge', forms, {
      responseType: 'blob',
    })
  }
  viewpdffile(forms: string[]) {
    return this._http.post('/api/GetDisclosure/Getpdf', forms, {
      responseType: 'blob',
    })
  }
  viewpdffileopen(forms: string[]) {
    return this._http.post('/api/GetDisclosure/Getpdfopen', forms, {
      responseType: 'blob',
    })
  }
  viewOtherpdffile(forms: string[]) {
    return this._http.post('/api/GetDisclosure/GetOtherpdf', forms, {
      responseType: 'blob',
    })
  }
  viewCorpdffile(forms: string[]) {
    return this._http.post('/api/GetDisclosure/GetCorresppdf', forms, {
      responseType: 'blob',
    })
  }
    viewAccountpdffile(forms: string[]) {
    return this._http.post('/api/GetDisclosure/GetAccountpdf', forms, {
      responseType: 'blob',
    })
  }
  viewDriverpdffile(forms: string[]) {
    return this._http.post('/api/GetDisclosure/GetDriverlpdf', forms, {
      responseType: 'blob',
    })
  }
  getPdfAccountForms(forms: any): Observable<any> {
    return this._http.post('/api/GetDisclosure/GetAccountFormPDF', forms, {
      responseType: 'blob',
    })
  }
  getpdfforms(f: any): Observable<any> {
    return this._http.post('/api/GetDisclosure/Getpdf', f, { 
      observe: 'response', 
      responseType: 'blob' 
    }).pipe(
      catchError((error) => {
        const errMsg = error.message || 'Failed to fetch PDF file';
        console.error('Error fetching PDF:', errMsg);
        return throwError(() => new Error(errMsg));
      })
    );
  } 

/*   getpdfforms(f: any): Observable<any> {
    return this._http.post('/api/GetDisclosure/Getpdf', f, { responseType: 'blob' })
  } */
  getPdfAccountlist(blotId: any): Observable<any> {
    return this._http.post(
      `/api/FileManagerCredentials/GetFileList?blotterId=${blotId}`,
      blotId,
    )
  }
  getPdfOtherlist(blotId: any): Observable<any> {
    return this._http.post(
      `/api/FileManagerCredentials/GetFileOtherList?blotterId=${blotId}`,
      blotId,
    )
  }
  getPdfCorresponlist(blotId: any): Observable<any> {
    return this._http.post(
      `/api/FileManagerCredentials/GetFileCorrespondList?blotterId=${blotId}`,
      blotId,
    )
  }
    getPdfDriverlicenselist(blotId: any): Observable<any> {
    return this._http.post(
      `/api/FileManagerCredentials/GetFileDriverList?blotterId=${blotId}`,
      blotId,
    )
  }
      getPdfAccountPdflicenselist(blotId: any): Observable<any> {
    return this._http.post(
      `/api/FileManagerCredentials/GetFileAccountList?blotterId=${blotId}`,
      blotId,
    )
  }
  /* // Example Angular/TypeScript
this.http.post('/api/FileManagerCredentials/Getpdf', formNames, { observe: 'response', responseType: 'blob' })
  .subscribe(response => {
    const isCorrupt = response.headers.get('X-Pdf-Corrupt') === 'true';
    if (isCorrupt) {
      // Handle corrupt file - trigger direct download
      console.warn('PDF was corrupt, downloading original file');
    }
    // Download the blob regardless
    const blob = response.body;
    // ... save/display logic
  });
  } */
  getPdfToOpen(forms: string[]) {
    return this._http.post('/api/FileManagerCredentials/Getpdf', forms, {
      responseType: 'blob',
    })
  }
  // Returns a token for OpenPdf/{token}/{fileName}, a plain GET URL the browser
  // can open directly so its PDF viewer keeps the real file name.
  preparePdfToOpen(forms: string[]): Observable<{ token: string }> {
    return this._http.post<{ token: string }>('/api/FileManagerCredentials/PrepareOpenPdf', forms)
  }
  getPdflicenseForms(forms: any): Observable<any> {
    return this._http.post(
      '/api/Showfolderfile/GetDriverlicenseTabpdfs',
      forms,
      { responseType: 'blob' },
    )
  }

  CheckdatabasedOffTaxId(data: any): Observable<any> {
    return this._http
      .post<any[]>(`/api/TaxIDMask/CheckTxd`, data)
      .pipe(catchError(this.handleError))
  }

  private handleError(error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    return Promise.reject(errMsg)
  }
}
